import { validateNotEmpty } from 'app/validators'

export const columns = [
  {
    name: 'notes',
    label: 'Add details about this termination reason',
    widget: 'wysiwyg',
    validate: validateNotEmpty
  },
  {
    widget: 'infobox',
    infoTitle: 'Note:',
    messages: [
      'Any sessions booked after the termination date mentioned above will automatically be cancelled.'
    ]
  }
]
